import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { routes } from '../routes/routes';

export const authGuard: CanActivateFn = (route, state) => {

  const authService = inject(AuthService);
  const router = inject(Router);

  const isAuthenticated = authService.isAuthenticated();
  const mustChangePassword = authService.isPasswordChangeRequired();

  // não autenticado
  if (!isAuthenticated) {
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  // permitir acessar login ou change-password
  if (state.url === routes.login || state.url === routes.changePassword) {
    return true;
  }

  // obrigar troca de senha
  if (mustChangePassword) {
    router.navigate([routes.changePassword]);
    return false;
  }

  return true;
};